import { useAtom } from "jotai";

import { listParamsPreviewAtom } from "./list-params-preview.state";

export const useParamsPreview = () => {
  const [preview, setPreview] = useAtom(listParamsPreviewAtom);

  const togglePreview = () => {
    setPreview((value) => !value);
  };

  return {
    preview,
    togglePreview,
  };
};
